/**
 * Flint Fires - Complete the Look Section
 * Carousel navigation and add to cart functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Target our wrapper using the successful pattern
  const section = document.querySelector('.flint-complete-the-look');
  if (!section) return;
  
  const carouselWrapper = section.querySelector('.flint-complete-look__carousel-wrapper');
  if (!carouselWrapper) return;
  
  const carousel = carouselWrapper.querySelector('.flint-complete-look__carousel');
  const prevButton = carouselWrapper.querySelector('.flint-complete-look__nav--prev');
  const nextButton = carouselWrapper.querySelector('.flint-complete-look__nav--next');
  const productCards = carousel.querySelectorAll('.flint-complete-look__product-card');
  
  if (!carousel || !prevButton || !nextButton || productCards.length === 0) return;
  
  let currentIndex = 0;
  let itemsPerView = getItemsPerView();
  let maxIndex = Math.max(0, productCards.length - itemsPerView);
  
  // Get items per view based on screen size
  function getItemsPerView() {
    const width = window.innerWidth;
    if (width < 750) return 1; // Mobile: show 1 (but actually uses horizontal scroll)
    if (width < 1000) return 2; // Small tablet
    if (width < 1200) return 3; // Tablet
    return 4; // Desktop
  }
  
  // Update carousel position
  function updateCarousel() {
    if (window.innerWidth < 750) {
      // Mobile uses native scroll, don't transform
      return;
    }
    
    // Hide arrows - Grid layout displays all items in rows, no scrolling needed
    // Desktop: 4 cols × 2 rows = 8 capacity
    // Tablet: 3 cols × 2 rows = 6 capacity  
    // Small tablet: 2 cols × 3 rows = 6 capacity
    const width = window.innerWidth;
    let gridCapacity;
    
    if (width >= 1200) {
      gridCapacity = 8; // 4 columns, 2 rows
    } else if (width >= 1000) {
      gridCapacity = 6; // 3 columns, 2 rows
    } else {
      gridCapacity = 6; // 2 columns, 3 rows
    }
    
    // Always hide arrows since grid displays all items in rows
    const needsNavigation = productCards.length > gridCapacity;
    
    if (needsNavigation) {
      prevButton.style.display = 'flex';
      nextButton.style.display = 'flex';
      
      const cardWidth = productCards[0].offsetWidth;
      const gap = 24; // Match CSS gap
      const translateX = -(currentIndex * (cardWidth + gap));
      
      carousel.style.transform = `translateX(${translateX}px)`;
      
      // Update button states
      prevButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex >= maxIndex;
    } else {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
      carousel.style.transform = 'none'; // Reset transform
      return;
    }
  }
  
  // Previous button
  prevButton.addEventListener('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });
  
  // Next button
  nextButton.addEventListener('click', function() {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  });
  
  // Add to cart functionality - Using our successful pattern from Flint Hero
  const addForms = section.querySelectorAll('.flint-complete-look__add-form');
  
  addForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      console.log('🛒 Complete the Look - Add to cart form submitted');
      
      const button = this.querySelector('.flint-complete-look__add-button');
      const originalText = button.innerHTML;
      const formData = new FormData(this);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1');
      
      if (!variantId) {
        console.error('🛒 No variant ID found');
        return;
      }
      
      console.log(`🛒 Adding to cart: ${variantId}, Qty: ${quantity}`);
      
      // Show loading state
      button.disabled = true;
      button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 12 12" to="360 12 12" repeatCount="indefinite"/></circle></svg> Adding...';
      
      // Use our successful AJAX cart pattern
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(response => response.json())
      .then(data => {
        console.log('🛒 Cart add successful:', data);
        
        // Success state
        button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Added!';
        
        // CRITICAL FIX: Refresh cart drawer content from server
        // This ensures empty cart gets updated HTML structure
        setTimeout(() => {
          refreshCartDrawerContent();
        }, 300);
        
        // Open drawer after content is refreshed
        setTimeout(() => {
          // Find and open the cart drawer directly
          const cartDrawer = document.querySelector('.cart-drawer, cart-drawer-component');
          
          if (cartDrawer) {
            // Try calling open() method if it exists
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if ('open' in cartDrawer) {
              cartDrawer.open = true;
            } else {
              cartDrawer.setAttribute('open', 'true');
              cartDrawer.dispatchEvent(new CustomEvent('open', { bubbles: true }));
            }
            
            // Update counter after drawer opens
            setTimeout(() => {
              updateCartCountWithVisibilityFix();
            }, 400);
          } else {
            // Fallback - try clicking cart icon
            const cartIcon = document.querySelector('[data-cart-count], .cart-count, button[aria-label*="Cart"]');
            if (cartIcon) {
              cartIcon.click();
              setTimeout(() => {
                updateCartCountWithVisibilityFix();
              }, 400);
            }
          }
        }, 800);
        
        // Reset button after delay
        setTimeout(() => {
          button.disabled = false;
          button.innerHTML = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('🛒 Cart add failed:', error);
        
        // Error state
        button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Error';
        
        // Reset button after delay
        setTimeout(() => {
          button.disabled = false;
          button.innerHTML = originalText;
        }, 2000);
      });
    });
  });
  
  // Initialize carousel
  updateCarousel();
  
  // Initialize Flickity on mobile for smooth scrolling
  let flkty = null;
  
  function initMobileCarousel() {
    if (window.innerWidth < 750 && !flkty && productCards.length > 1) {
      // Load Flickity if not already loaded
      if (typeof Flickity === 'undefined') {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
        script.onload = function() {
          startFlickity();
        };
        document.head.appendChild(script);
      } else {
        startFlickity();
      }
    } else if (window.innerWidth >= 750 && flkty) {
      // Destroy Flickity on desktop
      flkty.destroy();
      flkty = null;
    }
  }
  
  function startFlickity() {
    if (flkty || window.innerWidth >= 750) return;
    
    flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: true,
      draggable: true,
      freeScroll: false,
      wrapAround: false,
      groupCells: false,
      selectedAttraction: 0.025,
      friction: 0.28,
      resize: true
    });
  }
  
  // Initial check
  initMobileCarousel();
  
  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      itemsPerView = getItemsPerView();
      maxIndex = Math.max(0, productCards.length - itemsPerView);
      
      // Reset to beginning if current index is now invalid
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }
      
      updateCarousel();
      initMobileCarousel();
    }, 250);
  });
  function refreshCartDrawerContent() {
    console.log('🛒 Refreshing cart drawer content from server');
    
    const cartDrawer = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
    if (!cartDrawer) {
      console.log('🛒 No cart drawer found in DOM');
      return;
    }
    
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
        
        if (newCartDrawer) {
          cartDrawer.innerHTML = newCartDrawer.innerHTML;
          console.log('🛒 Cart drawer content refreshed successfully');
          
          // CRITICAL FIX: Update counter IMMEDIATELY after drawer refresh
          setTimeout(() => {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Fix the counter bubble parent (has visually-hidden class)
                const cartBubbles = document.querySelectorAll('.cart-bubble');
                cartBubbles.forEach(bubble => {
                  bubble.classList.remove('visually-hidden');
                  bubble.classList.remove('hidden');
                });
                
                // Fix and UPDATE the counter elements at the same time
                const counterElements = document.querySelectorAll('.cart-count, [data-cart-count], .cart-bubble__text-count, [data-testid="cart-bubble"]');
                counterElements.forEach(el => {
                  el.textContent = cart.item_count;
                  el.classList.remove('hidden');
                  el.style.display = 'inline-block';
                  el.style.visibility = 'visible';
                  el.style.opacity = '1';
                });
                
                console.log('🛒 Counter updated and shown with correct value:', cart.item_count);
              })
              .catch(err => console.log('🛒 Counter quick update failed:', err));
          }, 50);
        }
      })
      .catch(error => {
        console.error('🛒 Error refreshing cart drawer:', error);
      });
  }
  
  /**
   * Update cart count with visibility fix for empty cart
   */
  function updateCartCountWithVisibilityFix() {
    console.log('🛒 Updating cart count with visibility fix');
    
    const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .cart-bubble__text-count, [data-testid="cart-bubble"]');
    
    if (cartCountElements.length > 0) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('🛒 Cart API response:', cart.item_count, 'items');
          
          // CRITICAL FIX: Remove visually-hidden from parent cart-bubble
          if (cart.item_count > 0) {
            const cartBubbles = document.querySelectorAll('.cart-bubble');
            cartBubbles.forEach(bubble => {
              bubble.classList.remove('visually-hidden');
              bubble.classList.remove('hidden');
            });
          }
          
          // Update all cart count elements
          cartCountElements.forEach(element => {
            element.textContent = cart.item_count;
            if (cart.item_count > 0) {
              element.style.display = 'inline-block';
              element.style.visibility = 'visible';
              element.style.opacity = '1';
              element.classList.remove('hidden');
              element.classList.remove('hide');
              element.classList.remove('invisible');
            }
          });
          
          console.log('🛒 Cart count update complete');
        })
        .catch(err => console.log('🛒 Cart count update failed:', err));
    }
  }
});
